import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_TRIAL_PURCHASED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_TRIAL_PURCHASED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_TRIAL_PURCHASED_SCHEMA);

export class TrialPurchasedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.trial_purchased;
  }

  get properties() {
    return this.toJS();
  }
}
